var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9996,
    cy: 13.9996,
    r: 13.4996,
    stroke: "#6C584C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_2652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.332 7.33337H10.6654C8.82442 7.33337 7.33203 8.82576 7.33203 10.6667V17.3334C7.33203 19.1743 8.82442 20.6667 10.6654 20.6667H17.332C19.173 20.6667 20.6654 19.1743 20.6654 17.3334V10.6667C20.6654 8.82576 19.173 7.33337 17.332 7.33337Z",
    stroke: "#6C584C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6678 13.58C16.75 14.1348 16.6553 14.7014 16.3969 15.1993C16.1386 15.6972 15.7299 16.1009 15.2289 16.3531C14.7278 16.6052 14.1601 16.693 13.6063 16.6039C13.0525 16.5148 12.5409 16.2533 12.1443 15.8567C11.7477 15.4601 11.4863 14.9485 11.3972 14.3948C11.308 13.841 11.3958 13.2732 11.648 12.7722C11.9002 12.2712 12.3039 11.8625 12.8018 11.6041C13.2996 11.3458 13.8663 11.251 14.4211 11.3333C14.9871 11.4172 15.511 11.6809 15.9156 12.0855C16.3201 12.4901 16.5839 13.014 16.6678 13.58Z",
    stroke: "#6C584C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.668 10.3334H17.6755",
    stroke: "#6C584C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_2652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIc);
export default __webpack_public_path__ + "static/media/INSTAGRAM_ic.af8f11f66e9397f87c04c3ceeee63546.svg";
export { ForwardRef as ReactComponent };